import https from "../repositories/https";
const resource = "/ticket";

export default {
  fetchSingle(ticketId, config) {
    return https.get(`${resource}/${ticketId}`, config);
  },

  fetchList(payload, config) {
    return https.post(`${resource}s.json`, payload, config);
  },

  create(payload, config) {
    return https.post(`${resource}.json`, payload, config);
  },

  delete(payload, config) {
    return https.delete(`${resource}/${payload.id}`, config);
  },

  update(payload, id, config) {
    return https.put(`${resource}/${id}`, payload, config);
  },

  fetchStatusList(payload, config) {
    return https.get(`${resource}/statuses.json`, payload, config);
  },

  fetchPriorityList(payload, config) {
    return https.get(`${resource}/priorities.json`, payload, config);
  },

  fetchChannelList(payload, config) {
    return https.get(`${resource}/channels.json`, payload, config);
  },

  getComments(payload, config) {
    return https.get(`${resource}/${payload.id}/comments`, config);
  },

  getActivities(ticketId, payload, config) {
    return https.get(`${resource}/${ticketId}/activities`, payload, config);
  },

  addNote(id, payload, config) {
    return https.post(`${resource}/${id}/note`, payload, config);
  },

  addReply(id, payload, config) {
    return https.post(`${resource}/${id}/reply`, payload, config);
  },

  forwardMsg(id, payload, config) {
    return https.post(`${resource}/${id}/comment/forward.json`, payload, config);
  },
  
  getThreads(ticketId, config) {
    return https.get(`${resource}/${ticketId}/threads.json`, config);
  },

  threadComments(ticketId, payload, config) {
    return https.get(`${resource}/${ticketId}/thread/${payload.id}/comments`, payload, config);
  },

  deleteThread(ticketId, payload, config) {
    return https.delete(`${resource}/${ticketId}/thread/${payload.id}`, config);
  },

  updateNote(id, payload, config) {
    return https.put(`/note/${id}`, payload, config);
  },

  deleteNote(payload, config) {
    return https.delete(`/note/${payload.id}`, payload, config);
  },

  getFile(url, config) {
    return https.get(`${url}`, config);
  },

  trash(payload, config) {
    return https.post(`${resource}s/trash.json`, payload, config);
  },

  restore(payload, config) {
    return https.post(`${resource}s/restore.json`, payload, config);
  },

  bulkUpdate(payload, config) {
    return https.put(`${resource}s/bulk_update`, payload, config);
  }
};
